import * as React from 'react';

import {CalendarSquareRegularEventIcon} from '../icon/svg/calendar-square-regular-event-icon';
import {ClockRegularIcon} from '../icon/svg/clock-regular-icon';
import {VideoCameraRegularIcon} from '../icon/svg/video-camera-regular-icon';
import {Stack} from '../layout/stack/stack';
import {Body} from '../typography/body';

export const BookingContent = () => {
    return (
        <Stack spacing={16}>
            <Body isBold={true} color='dark'>
                Book a Meeting
            </Body>
            <Body size='small'>
                Connect with one of our sales representatives to go over your needs and
                requirements.
            </Body>
            <Stack spacing={12}>
                <div className='pad-8 border-dk br-8 background-offwhite'>
                    <Stack isHorizontal={true} spacing={8} alignItems='center'>
                        <ClockRegularIcon size={16} wrapWithDiv={false} />
                        <Body size='small'>15 minutes</Body>
                    </Stack>
                </div>
                <div className='pad-8 border-dk br-8 background-offwhite'>
                    <Stack isHorizontal={true} spacing={8}>
                        <VideoCameraRegularIcon size={16} wrapWithDiv={false} />
                        <Body size='small'>A link will be emailed to participants</Body>
                    </Stack>
                </div>
                <div className='pad-8 border-dk br-8 background-offwhite'>
                    <Stack isHorizontal={true} spacing={8}>
                        <CalendarSquareRegularEventIcon size={16} wrapWithDiv={false} />
                        <Body size='small'>Schedule your preferred time</Body>
                    </Stack>
                </div>
            </Stack>
        </Stack>
    );
};
